<template>
  <div id="app">
    <div class="message-box__wrapper" style="z-index: 2002" v-if="isOpen" @click.stop="toggeleClick">
      <div class="message-box">
      <div class="message-box__header">
        <button class="icon-close" @click.stop="toggeleClick">
          <i class="el-icon-close"></i>
        </button>
      </div>
      <div class="message-box__content">
        <div v-html="messageData"></div>
      </div>
    </div>
    </div>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
''    <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false,
      isFirst: false,
      messageData: ''
    }
  },
  created () {
    // this.open()
    if (!this.isFirst) {
      this.$store.dispatch('getOperpopflg').then(res => {
        if (res) {
          this.isOpen = true
          this.isFirst = true
          this.messageData = res.operwconcontents
        }
      })
    }
  },
  methods: {
    toggeleClick () {
      this.isOpen = false
    },
    open () {
      const h = this.$createElement
      this.$msgbox({
        title: '',
        showConfirmButton: false,
        message: h('p', null, [
          h('h2', { style: 'text-align: center;' }, '关于电信局线路维修 我公司部分电话使用受影响的温馨提示 '),
          h('p', { style: 'margin-top: 10px;' }, '尊敬的各位业主、投标人：'),
          h(
            'p',
            { style: 'text-indent: 35px;line-height: 30px;' },
            '因我公司所在大楼物业维修工程而造成管井漏水，严重损坏管井内电信线路，我公司近一个月来电话故障不断，严重干扰到我公司正常开展各项工作，为了彻底解决问题，电信局将于2021年   8 月  16 日-- 2021年  8  月 25  日进行管网更换、调试，以此期间电话（87258495）使用可能会间歇性受到影响，若您在拨打我公司电话时，可能会因线路正在更换、调试而产生占线、无法接通等状况，请拨打我公司以下电话：'
          ),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '1、020-87250181'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '2、020-87254235'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '3、020-87609680'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '4、020-87643627'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '5、8006300080'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '招标一部直线电话: 020-87284129'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '招标三部直线电话: 020-87708256'),
          h('p', { style: 'text-indent: 35px;line-height: 30px;' }, '客服部直线: 020-87284591'),
          h('p', { style: 'text-align: right;line-height: 30px;' }, '广东元正招标采购有限公司'),
          h('p', { style: 'text-align: right;line-height: 30px;' }, '二0二一年 七月二十九 日')
        ])
      })
    }
  }
}
</script>

<style>
@import './assets/css/base.css';
@import './assets/css/animate.css';
#app {
  height: 100%;
}
.el-card__header {
  padding: 10px 20px !important;
}
.el-card.box-card {
  margin-bottom: 10px !important;
}
.el-table tr.current-row td {
  background-color: #c0ccda !important;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #c0ccda !important;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
.message-box__wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.5)
}
.message-box {
    text-align: left;
    display: inline-block;
    vertical-align: middle;
    background-color: #fff;
    width: 520px;
    border-radius: 3px;
    font-size: 16px;
    overflow: hidden;
    backface-visibility: hidden;
}
.message-box .message-box__header {
    position: relative;
    padding: 20px 20px 0
}
.message-box .message-box__content {
    padding: 30px 20px;
    color: #48576a;
    font-size: 14px;
    position: relative;
}
.message-box .message-box__header .icon-close {
    position: absolute;
    top: 19px;
    right: 20px;
    background: 0 0;
    border: none;
    outline: 0;
    padding: 0;
    cursor: pointer;
}
.message-box .message-box__header .icon-close .el-icon-close{
  color: #9999
}

</style>



// WEBPACK FOOTER //
// App.vue?d4a5ad0e